import Cookies from 'js-cookie'

const TokenKey = 'accessToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export  function getCookie(cookieName) {
  return Cookies.get(cookieName)
}

export  function setCookie(cookieName,cookie) {
  return Cookies.set(cookieName, cookie)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js